<template>
  <transition name="fade">
    <aside class="sideMenu" v-if="isOpenSidenav">
      <img @click="closeSideMenu" class="sideMenu__toggle" width="48px" src="static/images/menu_toggle.png" />
      <img class="sideMenu__logo" width="100px" src="static/images/claro_logo-white.png" />
      
      <h2 v-if="profileValidated" class="sideMenu__title">Mi Cuenta</h2>
      <p v-if="profileValidated" class="sideMenu__link" @click="go('profile')">Perfil</p>
      <p v-if="profileValidated" class="sideMenu__link" @click="go('history')">Historial de Compras</p>
      <p v-if="profileValidated" class="sideMenu__link" @click="go('renovacionauto')">Renovación automática</p>


      <h2 class="sideMenu__title">Otros sitios</h2>
      <a class="sideMenu__link" href="https://www.clarovideo.com" target="claro_video">Claro Video</a>
      <a class="sideMenu__link"  href="https://www.claromusica.com" target="claro_musica">Claro Música</a>
      <p class="sideMenu__link">Backtones</p>

      <h2 class="sideMenu__title">Consultas</h2>
      <p class="sideMenu__link">Tiendas Claro</p>

      <h2 class="sideMenu__title">Ayuda</h2>
      <p class="sideMenu__link" @click="go('faqs')">Preguntas Frecuentes</p>
      <p class="sideMenu__link">Tutorial</p>
    </aside>
  </transition>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'sidenav',
  methods: {
    ...mapActions([
      'toggleSidenav'
    ]),
    closeSideMenu() {
      this.toggleSidenav(false);
    },
    go(route) {
      global.router.push(route);
      this.closeSideMenu();
    }
  },
  computed: {
    ...mapGetters([
      'pin',
      'msisdn',
      'flowType',
      'isOpenSidenav'
    ]),
    profileValidated() {
      return ((this.msisdn.length === 8 && this.flowType === '3g') || (this.flowType === 'wifi' && this.pin.length === 4));
    }
  }
};
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/Sidenav.vue